import { type App } from '~/app';

import { scrollIntoView } from '../../../../framework/scripts/utils/scroll';
import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Rich Media Banner');
    controller.addMountFunction(() => {
        mountRichMediaBanner(controller);
    })

    return controller.init();
}

export function mountRichMediaBanner( controller: JsController ) {
    const richMediaBanner = document.querySelector<HTMLElement>('.rich-media-banner')
    function updateMediaPanel (imageClass: string){
        const media = richMediaBanner?.querySelectorAll<HTMLElement>('.rich-media')
        if (media) {
            for (const mediaItem of media) {
                mediaItem.classList.remove('display')
            }

            for (const mediaItem of media) {
                if(mediaItem.classList.contains(imageClass)){
                    mediaItem.classList.add('display')
                }            
            }
        } 
    }
    function updateTextPanel (textPanelClass: string){
        const textPanels = richMediaBanner?.querySelectorAll<HTMLElement>('.rich-media-text')
        if (textPanels) {
            for (const textPanel of textPanels) {
                textPanel.classList.remove('show','active')
            }

            for (const textPanel of textPanels) {
                if(textPanel.classList.contains(textPanelClass)){
                    textPanel.classList.add('show','active')
                }            
            }
        } 
    }

    function updateTabs(id:string){
        const navLinks = richMediaBanner?.querySelectorAll<HTMLElement>('.nav-link')
        if (navLinks) {
            for (const navLink of navLinks) {
                navLink.classList.remove('active')
            }

            for (const navLink of navLinks) {
                if(navLink.id=== id){
                    navLink.classList.add('active')
                    scrollIntoView(navLink, {
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest'
                    });
                }            
            }
        } 
    }

    if (richMediaBanner) {
        const navLinks = richMediaBanner.querySelectorAll<HTMLElement>('.nav-link')
        if (navLinks) {
            for (const tab of navLinks) {
                controller.addListener(tab, "click",()=>{
                    const tabId = tab.id
                    updateMediaPanel(tabId)
                    updateTabs(tabId)
                    scrollIntoView(tab, {
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest'
                    });
                }
                )            
            }
        }
        
    }   
    
    //Handle previous and next tab button click
    const prevTabButton = richMediaBanner?.querySelector<HTMLElement>('.prev-tab-button')
    const nextTabButton = richMediaBanner?.querySelector<HTMLElement>('.next-tab-button')
    if (prevTabButton && nextTabButton) {
        controller.addListener(prevTabButton, "click",()=>{
            const activeTab = richMediaBanner?.querySelector<HTMLElement>('.nav-link.active')
            const prevTab = activeTab?.previousElementSibling as HTMLElement
            if(prevTab){
                const tabId = prevTab.id
                updateMediaPanel(tabId)
                updateTabs(tabId)
                updateTextPanel(tabId)
            }
        })

        controller.addListener(nextTabButton, "click",()=>{
            const activeTab = richMediaBanner?.querySelector<HTMLElement>('.nav-link.active')
            const nextTab = activeTab?.nextElementSibling as HTMLElement
            if(nextTab){
                const tabId = nextTab.id
                updateMediaPanel(tabId)
                updateTabs(tabId)
                updateTextPanel(tabId)
            }
        })
    }

    // Handle scroll arrow click
    const slideArrow = document?.querySelector<HTMLElement>('.scroll-to-bottom-of-hero');

    if (slideArrow && richMediaBanner) {
        controller.addListener(slideArrow, "click", () => {
            const navigation = document.querySelector<HTMLElement>('.navigation');
            const navigationHeight = navigation ? navigation.clientHeight : 0;
            const scrollToPos = richMediaBanner.getBoundingClientRect().bottom + window.scrollY - navigationHeight;
            window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
        });
        
    }
}


